import { createUseStyles } from 'react-jss';
import { ITheme, mediaQuery } from '@quicktools/shared-components';

const useStyles = createUseStyles<string, { tooltipLeft: number; tooltipTop: number }, ITheme>(
  ({ breakpoints }: ITheme) => ({
    root: {
      background: '#fff',
      position: 'relative',
      cursor: 'pointer',
      borderBottom: '1px solid #5e5e5e29',
      justifyContent: 'space-between',
      padding: 20,

      '&:first-of-type': {
        borderRadius: [16, 16, 0, 0],
      },
      '&:last-of-type': {
        borderRadius: [0, 0, 16, 16],
        marginBottom: 0,
      },
      '&:hover': {
        background: '#fcfcfd',
      },
      '&:hover .copy-button': {
        display: 'block',

        [mediaQuery(breakpoints.tablet)]: {
          display: 'none',
        },
      },
      '&:hover .tooltip-icon': {
        display: 'block',

        [mediaQuery(breakpoints.tablet)]: {
          display: 'none',
        },
      },
      '&.active': {
        backgroundColor: '#F6E8F1B2',
      },

      [mediaQuery(breakpoints.tablet)]: {
        padding: [12, 16],
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    generatedText: {
      fontSize: 24,
      overflowWrap: 'anywhere',

      '&.high01': {
        paddingBlock: 58,

        [mediaQuery(breakpoints.tablet)]: {
          paddingBlock: 34,
        },
      },
      '&.high02': {
        paddingBlock: 70,

        [mediaQuery(breakpoints.tablet)]: {
          paddingBlock: 54,
        },
      },
      '&.highBottom': {
        paddingBottom: 86,

        [mediaQuery(breakpoints.tablet)]: {
          paddingBottom: 56,
        },
      },
      '&.highTop': {
        paddingTop: 86,

        [mediaQuery(breakpoints.tablet)]: {
          paddingTop: 60,
        },
      },

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: 16,
      },
    },

    tooltip: {
      position: 'absolute',
      top: '100%',
      zIndex: 99,
      display: 'none',
      '&.active': {
        display: 'block',

        [mediaQuery(breakpoints.tablet)]: {
          display: 'none',
        },
      },
    },
    indicator: {
      position: 'absolute',
      top: -8,
      right: 'calc(50% - 12.5px)',
    },

    btnContainer: {
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      justifyContent: 'flex-end',
      left: 0,
      position: 'absolute',
      top: 0,
      width: '100%',
    },
    copyButton: {
      minWidth: 104,
      height: 34,
      border: '2px solid var(--x-accent-1-1)',
      boxSizing: 'border-box',
      backgroundColor: '#FFF',
      color: 'var(--x-accent-1-1)',
      borderRadius: 8,
      display: 'none',
      fontSize: 14,
      cursor: 'pointer',
      marginRight: 12,
      fontWeight: 'bold',

      [mediaQuery(breakpoints.tablet)]: {
        display: 'none',
      },

      '&.active': {
        background: '#C209C1',
        color: '#FFFF',
        display: 'block',

        [mediaQuery(breakpoints.tablet)]: {
          display: 'none',
        },
      },
    },
    copiedTooltip: {
      position: 'absolute',
      top: ({ tooltipTop }) => tooltipTop - 52,
      zIndex: 10,
      left: ({ tooltipLeft }) => tooltipLeft - 42,
      width: 84,
      display: 'none',
      [mediaQuery(breakpoints.tablet)]: {
        display: 'block',
      },
    },

    asciiPre: {
      fontFamily: 'monospace',
      fontSize: 12,
      whiteSpace: 'pre',
      overflowX: 'auto',
    },
    asciiBtnContainer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'flex-end',
      right: 10,
      position: 'absolute',
      top: 'calc(50% - 17px)',
    },
  }),
  { name: 'FontRow' },
);

export default useStyles;
